import byteSize from 'byte-size'

export const computeEdgeDashes = (edgeCount, maxCount) => {
  const baseDash = 5
  const baseGap = 7
  const k = 10
  const minScale = 0.5

  const scaleFactor = Math.max(minScale, edgeCount / maxCount)
  const dash = Math.round(baseDash * scaleFactor * k)
  const gap = Math.round(baseGap * scaleFactor * k)

  return [dash, gap]
}

export const humanReadableBytes = (bytesVal) => {
  const byteSizeRes = byteSize(bytesVal)
  return `${Number.parseFloat(byteSizeRes.value).toFixed(2)}${byteSizeRes.unit}`
}
